// Module
var code = "<div class=\"hotkey-details-panel-groups\">\r\n    {{#each groupItems: i}}\r\n        <hotkeysSettingsGroup groupItem=\"{{groupItems[i]}}\" on-ValueChanged=\"ValueChanged\" />\r\n    {{/each}}\r\n</div>";
// Exports
export default code;